import AppBar from '@mui/material/AppBar';
import Toolbar from '@mui/material/Toolbar';
import { useTheme, SxProps } from '@mui/material/styles';
import useScrollPosition from '../../utils/hooks/useScrollPosition';

type StickyFooterProps = {
  children: React.ReactNode;
  position?: 'fixed' | 'sticky';
  addBoxShadow?: boolean;
  customSx?: SxProps;
  addToolBar?: boolean; // To add a toolbar below the footer
};

function StickyFooter({ children, position, addBoxShadow, customSx, addToolBar = true }: StickyFooterProps) {
  const theme = useTheme();
  const { isAtBottomOfPage } = useScrollPosition();

  return (
    <>
      <AppBar
        position={position}
        sx={{
          top: 'auto',
          bottom: 0,
          backgroundColor: theme.palette.background.default,
          border: 'none',
          boxShadow: isAtBottomOfPage || !addBoxShadow ? 0 : '0px -4px 12px 0px rgba(0,0,0,0.08)',
          ...customSx,
        }}
        data-testid='sticky-footer'
      >
        {children}
      </AppBar>
      {/* Render toolbar for layout spacing if addToolBar is true */}
      {addToolBar && <Toolbar data-testid='sticky-footer-toolbar' />}
    </>
  );
}

StickyFooter.defaultProps = {
  position: 'fixed',
  addBoxShadow: true,
  customSx: undefined,
  addToolBar: true, // Default to true to add a toolbar below the footer
};

export default StickyFooter;
